import "core-js/modules/es.array.map.js";
export var getManagementCompanyInitialValue = function getManagementCompanyInitialValue(managementCompany) {
  return managementCompany && managementCompany.length > 0 ? managementCompany.map(function (item) {
    return {
      id: item.id,
      label: item.name,
      counter: null
    };
  }) : [];
};
export var getCategoryInitialValue = function getCategoryInitialValue(category) {
  return category && category.length > 0 ? category.map(function (item) {
    return {
      id: item.id,
      label: item.name,
      counter: null
    };
  }) : [];
};
export var getRiskInitialValue = function getRiskInitialValue(risk) {
  return risk && risk.length > 0 ? risk.map(function (item) {
    return {
      id: item.risk,
      label: item.label,
      counter: null
    };
  }) : [];
};
export var getOriginInitialValue = function getOriginInitialValue(origin) {
  return origin ? [{
    id: origin.id,
    label: origin.label,
    counter: null
  }] : [];
};
export var getIndexedInitialValue = function getIndexedInitialValue(indexed) {
  return indexed ? [{
    id: indexed.id,
    label: indexed.name,
    counter: null
  }] : [];
};
export var getOrderInitialValue = function getOrderInitialValue(order) {
  return order ? [{
    id: "-".concat(order.slug),
    label: order.name,
    counter: null
  }] : [];
};